import Styles from './styles.module.css';
import React, { useRef } from 'react';
import WaitImg from '../../../../../../image/default/wait.png';

type BasicInfoSectionProps = {
  imageUrl: string;
  stagedPreviewUrl: string | null;
  onSelectImage: (file: File) => void;
};

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  imageUrl, stagedPreviewUrl, onSelectImage,
}) => {

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files[0]) {
      onSelectImage(e.target.files[0]);
    }
  }

  return (
    <div className={Styles.box}>

      <div className={Styles.imageWrap}>
        <img
          className={Styles.image}
          src={stagedPreviewUrl ?? imageUrl}
          alt=""
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = WaitImg;
          }}
        />
        <button type="button" className={Styles.changeButton} onClick={() => fileInputRef.current?.click()}>
          画像を変更
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className={Styles.hiddenInput}
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
}

export default BasicInfoSection;
